export default

{
    version: '1.3.5',
    welcomeScreen: {
        welcome: 'Welcome',
        reload: 'Reload',
        clickReload: 'If you have just added games to your account, click reload.',
        findMore: 'Find more games to track in your account settings',
        songList: 'Songs list',
        courses: 'Courses',
        songs: 'Songs',
        total: 'Total',
        system: 'System',
        arcade: 'Arcade',
        singles: 'Single Points',
        doubles: 'Double Points',
        singleCourses: 'Single Courses',
        doubleCourses: 'Double Courses',
        tips: 'How it works',
        selectGames: 'Add game',
        trackedGames: 'Tracked games',
        games: 'Games',
        players: 'Players',
        highScoreRankings: 'High Score Rankings',
        highScore: 'High Score',
        leaderboard: 'Leaderboard',
        seeInfo: 'See Info',
        hideInfo: 'Hide Info',
        addArcade: 'Add arcade',
    },
    menu: {
        app: 'App',
        overview: 'Dashboard',
        settings: 'Settings',
        logout: 'Logout',
        aboutAndInfo: 'About & Info',
        admin: 'Admin',
        back: 'Back',
        arcadeRanking: 'Arcade Ranking',
        games: 'Games',
        arcadesSelect: 'Arcades',
        login: 'Login',
        songLeaderboard: 'Song Leaderboard',
        profile: 'Profile',
    },
    listScreen: {
        player: 'Player | Players',
        game: 'Game | Games',
        search: 'Search',
        filters: 'Filters',
        target: 'Target',
        filter: 'Filter',
        nameArtist: 'Name / Artist',
        level: 'Level',
        filterOn: 'on',
        songName: 'Song Name',
        favorite: 'Favorite',
        artistAlias: 'Artist / Alias',
        favoriteShort: 'Fav',
        targetShort: 'Tar',
        searchName: 'Search by name',
        fullComboCap: 'FULL-COMBO',
        name: 'Name',
        artist: 'Artist',
        genre: 'Genre',
        easy: 'Easy',
        normal: 'Normal',
        hard: 'Hard',
        another: 'Another',
        title: 'Song name',
        easyLevel: 'Easy Level',
        normalLevel: 'Normal Level',
        hardLevel: 'Hard Level',
        anotherLevel: 'Another Level',
        easyDoubleLevel: 'E Double Level',
        normalDoubleLevel: 'N Double Level',
        hardDoubleLevel: 'H Double Level',
        anotherDoubleLevel: 'A Double Level',
        easyScore: 'Easy Score',
        normalScore: 'Normal Score',
        hardScore: 'Hard Score',
        anotherScore: 'Another Score',
        noSongs: 'No songs found',
    },
    filter: {
        songFilters: 'Song Filters',
        none: 'None',
        failed: 'Failed',
        clear: 'Cleared',
        cleared: 'Cleared',
        fullCombo: 'Full Combo',
        single: 'Single',
        double: 'Double',
        singles: 'Singles',
        doubles: 'Doubles',
        favorite: 'Favorite',
        target: 'Target',
        playStyle: 'Play Style',
        otherFilters: 'Other Filters',
        applyFilters: 'Apply Filters',
        filterOnClear: 'Filter on Clear',
        level: 'Level',
        fullComboShort: 'FC',
        setTarget: 'Set Target',
        setFavorite: 'Set Favorite',
        save: 'Save',
        grade: 'Grade',
        score: 'Score',
        update: 'Update',
        show: 'Show',
        filerOn: 'Filter on',
        onlySinglePlayer: 'Battle Mode not available',
        onlySinglePlayerInfo: 'When playing in multiplayer, the course can not be played in Battle Mode. The title will yellow out and the course will be switched to couple mode when selected.',
        trackAll: 'Track all',
        removeFilters: 'Remove',
    },
    login: {
        profileQr: 'Profile QR',
        viewProfile: 'View Profile',
        copyCode: 'Copy Code',
        copied: 'Code is copied',
        languageIs: 'English',
        close: 'Close',
        login: 'Login',
        selectLanguage: 'Language',
        rankingUrl: 'Ranking URL',
        aboutApp: 'About app',
        register: 'Register',
        password: 'Password',
        version: 'Version',
        profileUrl: 'Profile URL',
        email: 'Email Address',
        progressTracker: 'Progress tracker for retro music games',
        emailIsSave: 'We will never share your email with anyone else.',
        nameInProfile: 'Will be displayed in your profile.',
        gametagName: 'Game tag / name',
        formInvalid: 'Form is invalid',
        confirmPassword: 'Confirm Password',
        goLogin: 'Go to login',
        passwordReset: 'Password Reset',
        emailWillBeSendToReset: 'An email will be sent to you with instructions on how to reset your password.',
        sendReset: 'Send Reset Email',
    },
    settings: {
        settings: 'Account Settings',
        singlePLay: 'Single Play',
        doublePlay: 'Double Play',
        accountDetails: 'Account',
        gameSelect: 'Games',
        gameSelectInfo: 'Choose the games you want to track.',
        accountInfo: 'Set your account information.',
        arcadeCode: 'Arcade ranking code',
        info: 'Info',
        favoriteGame: 'Favorite Game',
        selectTheme: 'Select Theme',
        updated: 'Updated',
        codeSlot1: 'Slot 1',
        codeSlot2: 'Slot 2',
        codeSlot3: 'Slot 3',
        seeRanking: 'See Ranking',
    },
    about: {
        aboutApp: 'About the app',
        trackerApp: 'Beatmania Progress Tracker App',
        keyFeatures: 'Key Features:',
        progressTracking: 'Progress Tracking: Keep track of your scores, progress and achievements.',
        arcadeHighScores: 'Arcade high scores: Keep track of your high scores in your local arcade.',
        translations: 'Translations: Available in English and Japanese.',
        gamesSupported: 'Games supported:',
        howToSubmit: 'How to submit',
        setHomeScreen: 'Set the app to your home screen or use the website and start tracking your progress in Beatmania!',
        github: 'Github',
        info: 'Info',
        tipsTricks: 'Tips & Tricks',
        questionsFeedback: 'For any questions or feedback, please reach out to us at',
        valueInput: 'We value your input and are continuously working to improve the app for the community.',
        broughtBy: 'Brought you by',
        notAffiliated: 'The app is not affiliated with Konami or any other company.'
    },
    tips: {
        tipsForUsers: 'Tips for users',
        findInfo: 'Find info on how to use this app',
        whatIsApp: 'What is this app?',
        notAGame: 'It is not a game, but a tool.',
        bestWay: 'Best way to use this app',
        singleSongs: 'Single songs:',
        fullCourses: 'Full courses:',
        arcadeCodeRanking: 'Arcade Code an Ranking',
        arcadeCodeInfo: 'The arcade code is used to link your account to the arcade you play at, you can find the code at the arcade.',
        arcadeNotListed: 'Is your arcade not listed?',
        arcadesOnRequest: 'Arcades can be added on request.',
        tipScorePictures: 'TIP: Take score pictures',
        scoreShownShort: 'Since the score is shown for a short period in some game, make sure to take a picture.',
        uploadEndSession: 'Uploading them at the end of your play session is the easiest way to make sure you don\'t forget/miss any scores.'
    },
    import: {
        songsToJson: 'Songs to JSON',
        convert: 'Convert',
        copyJson: 'Copy JSON to Clipboard',
        pressConvert: 'Press convert to make JSON',
        formatExcel: 'Format copied from excel:'
    },
    admin: {
        adminPanel: 'Admin Panel',
        updateSongs: 'Update Songs',
        updateGames: 'Update Games',
        updateCourses: 'Update Courses',
        updateArcades: 'Update Arcades',
        updateAchievements: 'Update Achievements',
        userList: 'User list',
        songToJson: 'Song to JSON',
        updateStats: 'Update stats'
    },
    users: {
        usersList: 'Users list',
        name: 'Name',
        lastLogin: 'Last login'
    },
    arcade: {
        arcadeRankings: 'Arcade Rankings',
        selectArcade: 'Select Arcade',
        selectGame: 'Select Game',
        location: 'Location:'
    },
    songRankings: {
        songLeaderboard: 'Song Leaderboard',
        chooseSong: 'Choose song'
    },
    challenges: {
        challenges: 'Challenges',
        manage: 'Manage Challenges',
        chooseChallenge: 'Choose challenge',
        chooseCourse: 'Choose course',
        new: 'New challenge',
        title: 'Challenge title',
        instructions: 'Instructions (optional)',
        state: 'Status',
        status: { draft: 'Draft', open: 'Open', closed: 'Closed' },
        saved: 'Challenge saved.',
        saving: 'Saving…',
        loading: 'Loading…',
        shareQr: 'Share QR',
        downloadQr: 'Download QR',
        view: 'View challenge',
        courseLocked: 'The arcade and course are fixed once scores have been submitted.',
        courseSongs: 'Course songs',
        noChallenges: 'No challenges for this arcade yet.',
        nickname: 'Leaderboard name',
        clearStatus: 'Clear status',
        resultHint: 'Enter score and grade as shown on the result screen.',
        guestHint: 'No account needed. Your leaderboard name is public.',
        accountHint: 'Also saves improvements to your course progress. Your leaderboard name is public.',
        submitScore: 'Submit score',
        submitted: 'Score submitted.',
        progressSaved: 'Saved to your course progress. Your personal best is kept.',
        keepScore: 'Keep this result in your account and track your next personal best.',
        loginSave: 'Log in & save to my progress',
        registerSave: 'Create account & keep this score',
        saveToProgress: 'Save to my progress',
        claimHint: 'Use this device and browser to claim your guest scores.',
        anotherAttempt: 'Submit another attempt',
        retry: 'Retry this submission',
        closedHint: 'This challenge is closed. The leaderboard remains available.',
        leaderboard: 'Challenge leaderboard',
        bestAttempt: 'Each player’s best score is shown.',
        noScores: 'No scores yet. Be the first to enter.',
        rank: 'Rank',
        arcadeChallenges: 'Arcade challenges',
        discord: {
            newResult: '🏆 New challenge result',
            player: 'Player',
            challenge: 'Challenge',
            score: 'Score',
            grade: 'Grade',
            clear: 'Clear',
            failed: 'Failed',
            cleared: 'Cleared',
            fullCombo: 'Full combo',
            leaderboard: 'View leaderboard'
        },
        errors: {
            invalidInput: 'Check the required fields. Enter a whole-number score of 0 or higher with the grade shown by the game.',
            requestFailed: 'Could not complete the request. Please try again.',
            signInRequired: 'Please log in again to save your course progress.',
            adminRequired: 'This account is not enabled for challenge administration.',
            challengeNotFound: 'This challenge is not available.',
            courseNotFound: 'The course is no longer available.',
            accountNotFound: 'Your account could not be found.',
            invalidCourse: 'Choose a course from a game available at this arcade.',
            challengeLocked: 'A challenge with scores cannot change arcade or course, or return to draft.',
            challengeClosed: 'This challenge is not accepting scores.',
            invalidSubmission: 'This submission could not be saved. Reload and try again.',
            cannotClaim: 'This result cannot be claimed by this account. Use the original browser and account.',
            tooManyAttempts: 'Please wait a minute before trying again.',
            methodNotAllowed: 'Could not complete the request. Please try again.'
        }
    }
}
